export function extractParamsFromMultiSelectObject(manyEntity) {
  return {
    all: manyEntity?.exclude.length ? false : manyEntity?.all ?? false,
    include: manyEntity?.include?.map(entity => entity.id || entity.value) ?? [],
    exclude: manyEntity?.exclude?.map(entity => entity.id || entity.value) ?? [],
  };
}

export function extractIdsFromMultiSelectObject(manyEntity) {
  return manyEntity?.include?.map(entity => entity.id) || [];
}

export function checkEmptyParams(many) {
  if (!many) return true;
  return many.include?.length === 0 && many.exclude?.length === 0 && many.all === false;
}

function normalizeClientType(clientType) {
  if (Array.isArray(clientType)) {
    return clientType.length === 1 ? clientType[0] : 'all';
  }

  return clientType || 'all';
}

function serializeScopeMany(value) {
  if (!value) {
    return undefined;
  }

  return extractParamsFromMultiSelectObject(value);
}

function appendClientsFilter(payload, serializedClients) {
  if (serializedClients && !serializedClients.all) {
    return { ...payload, clients: serializedClients };
  }

  return payload;
}

export function buildScopeFetchPayload(entityType, { projects, buildings, units, clients, clientType } = {}) {
  const serializedProjects = serializeScopeMany(projects);
  const serializedBuildings = serializeScopeMany(buildings);
  const serializedUnits = serializeScopeMany(units);
  const serializedClients = serializeScopeMany(clients);
  const normalizedClientType = normalizeClientType(clientType);

  switch (entityType) {
    case 'projects':
      return appendClientsFilter({ clientType: normalizedClientType }, serializedClients);
    case 'buildings': {
      const payload = appendClientsFilter({ clientType: normalizedClientType }, serializedClients);

      if (serializedProjects && !serializedProjects.all) {
        payload.projects = serializedProjects;
      }

      return payload;
    }
    case 'units': {
      const payload = appendClientsFilter({ clientType: normalizedClientType }, serializedClients);

      if (serializedBuildings && !serializedBuildings.all) {
        payload.buildings = serializedBuildings;
      }

      if (serializedProjects && !serializedProjects.all) {
        payload.projects = serializedProjects;
      }

      return payload;
    }
    case 'clients':
    case 'clientsForEvents': {
      const payload = appendClientsFilter({ clientType: normalizedClientType }, serializedClients);

      if (serializedUnits && !serializedUnits.all) {
        payload.units = serializedUnits;
      }

      if (serializedBuildings && !serializedBuildings.all) {
        payload.buildings = serializedBuildings;
      }

      if (serializedProjects && !serializedProjects.all) {
        payload.projects = serializedProjects;
      }

      return payload;
    }
    default:
      return {};
  }
}
